const init = () => {
  const header = document.querySelector(`#nav`)
  let lastScrollPosition = 0

  const showHeader = () => {
    header.style.display = `block`
  }

  const hideHeader = () => {
    header.style.display = `none`
  }

  const onScroll = () => {
    const curScroll = window.scrollY
    const scrollDiff = (lastScrollPosition - curScroll)
    const headerHeight = header.clientHeight
    if ((document.body.scrollHeight - headerHeight * 2) <= window.innerHeight || (scrollDiff < 10 && scrollDiff >= 0)) {
      return // do nothing
    }
    if (scrollDiff < 0 && curScroll > headerHeight) {
      hideHeader()
    } else {
      showHeader()
    }
    lastScrollPosition = curScroll
  }

  window.addEventListener(`scroll`, onScroll)
}

// document.addEventListener('DOMContentLoaded', init, false)